import { createFileRoute, retainSearchParams } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/integrations/connect/sap-concur/confirmation/',
)({
  search: { middlewares: [retainSearchParams(true)] },
});
